import { useQuery } from 'react-query';
import api, { QueryConfig } from '@shared/api';
import { ArtifactVersion } from '@artifacts/types/ArtifactVersionAsset';

interface GetArtifactVersion {
  pageSize: number;
  pageNumber: number;
  searchKeyword?: string;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
  types?: string[];

  workspaceName: string;
  artifactName: string;
  version?: string;

  alias?: string;
  versionOrAlias?: string;
  experimentKey?: string;

  signal?: AbortSignal;
}

const getArtifactVersion = async ({
  pageSize,
  pageNumber,
  searchKeyword,
  sortBy,
  sortOrder,
  types,
  workspaceName,
  artifactName,
  version,
  alias,
  versionOrAlias,
  signal
}: GetArtifactVersion): Promise<ArtifactVersion> => {
  const payload = {
    pageSize,
    pageNumber,
    searchKeyword,
    sortBy,
    sortOrder,
    types,
    workspaceName,
    artifactName,
    version,
    alias,
    versionOrAlias
  };

  const response = await api.post<ArtifactVersion>(
    `/artifacts/version`,
    payload,
    {
      signal
    }
  );

  return response.data;
};

interface UseArtifactVersionAssetsParams extends GetArtifactVersion {
  config?: QueryConfig<ArtifactVersion>;
}

const useArtifactVersion = ({
  pageSize,
  pageNumber,
  searchKeyword,
  sortBy,
  sortOrder,
  types,
  workspaceName,
  artifactName,
  version,
  alias,
  versionOrAlias,
  config = {}
}: UseArtifactVersionAssetsParams) => {
  return useQuery(
    [
      'artifactVersion',
      {
        workspaceName,
        artifactName,
        version,
        pageSize,
        pageNumber,
        searchKeyword,
        sortBy,
        sortOrder,
        types,
        alias,
        versionOrAlias
      }
    ],
    ({ signal }) =>
      getArtifactVersion({
        workspaceName,
        artifactName,
        version,
        pageSize,
        pageNumber,
        searchKeyword,
        sortBy,
        sortOrder,
        types,
        alias,
        versionOrAlias,
        signal
      }),
    {
      ...config,
      keepPreviousData: true
    }
  );
};

export default useArtifactVersion;
